import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Drawer as e } from "vaul";
import { cn as d } from "../../lib/utils.js";
function s({
  ...r
}) {
  return /* @__PURE__ */ a(e.Root, { "data-slot": "drawer", ...r });
}
function m({
  ...r
}) {
  return /* @__PURE__ */ a(e.Trigger, { "data-slot": "drawer-trigger", ...r });
}
function n({
  ...r
}) {
  return /* @__PURE__ */ a(e.Portal, { "data-slot": "drawer-portal", ...r });
}
function f({
  ...r
}) {
  return /* @__PURE__ */ a(e.Close, { "data-slot": "drawer-close", ...r });
}
function l({
  className: r,
  ...t
}) {
  return /* @__PURE__ */ a(
    e.Overlay,
    {
      "data-slot": "drawer-overlay",
      className: d(
        "fixed inset-0 z-50 bg-black/10 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0",
        r
      ),
      ...t
    }
  );
}
function v({
  className: r,
  children: t,
  ...i
}) {
  return /* @__PURE__ */ o(n, { children: [
    /* @__PURE__ */ a(l, {}),
    /* @__PURE__ */ o(
      e.Content,
      {
        "data-slot": "drawer-content",
        className: d(
          "group/drawer-content fixed z-50 flex h-auto flex-col bg-popover text-sm text-popover-foreground data-[vaul-drawer-direction=bottom]:inset-x-0 data-[vaul-drawer-direction=bottom]:bottom-0 data-[vaul-drawer-direction=bottom]:mt-24 data-[vaul-drawer-direction=bottom]:max-h-[80vh] data-[vaul-drawer-direction=bottom]:rounded-t-xl data-[vaul-drawer-direction=bottom]:border-t data-[vaul-drawer-direction=left]:inset-y-0 data-[vaul-drawer-direction=left]:left-0 data-[vaul-drawer-direction=left]:w-3/4 data-[vaul-drawer-direction=left]:rounded-r-xl data-[vaul-drawer-direction=left]:border-r data-[vaul-drawer-direction=right]:inset-y-0 data-[vaul-drawer-direction=right]:right-0 data-[vaul-drawer-direction=right]:w-3/4 data-[vaul-drawer-direction=right]:rounded-l-xl data-[vaul-drawer-direction=right]:border-l data-[vaul-drawer-direction=top]:inset-x-0 data-[vaul-drawer-direction=top]:top-0 data-[vaul-drawer-direction=top]:mb-24 data-[vaul-drawer-direction=top]:max-h-[80vh] data-[vaul-drawer-direction=top]:rounded-b-xl data-[vaul-drawer-direction=top]:border-b data-[vaul-drawer-direction=left]:sm:max-w-sm data-[vaul-drawer-direction=right]:sm:max-w-sm",
          r
        ),
        ...i,
        children: [
          /* @__PURE__ */ a("div", { className: "mx-auto mt-4 hidden h-1 w-[100px] shrink-0 rounded-full bg-muted group-data-[vaul-drawer-direction=bottom]/drawer-content:block" }),
          t
        ]
      }
    )
  ] });
}
function p({ className: r, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "drawer-header",
      className: d(
        "flex flex-col gap-0.5 p-4 group-data-[vaul-drawer-direction=bottom]/drawer-content:text-center group-data-[vaul-drawer-direction=top]/drawer-content:text-center md:gap-0.5 md:text-left",
        r
      ),
      ...t
    }
  );
}
function x({ className: r, ...t }) {
  return /* @__PURE__ */ a(
    "div",
    {
      "data-slot": "drawer-footer",
      className: d("mt-auto flex flex-col gap-2 p-4", r),
      ...t
    }
  );
}
function g({
  className: r,
  ...t
}) {
  return /* @__PURE__ */ a(
    e.Title,
    {
      "data-slot": "drawer-title",
      className: d(
        "font-heading text-base font-medium text-foreground",
        r
      ),
      ...t
    }
  );
}
function b({
  className: r,
  ...t
}) {
  return /* @__PURE__ */ a(
    e.Description,
    {
      "data-slot": "drawer-description",
      className: d("text-sm text-muted-foreground", r),
      ...t
    }
  );
}
export {
  s as Drawer,
  f as DrawerClose,
  v as DrawerContent,
  b as DrawerDescription,
  x as DrawerFooter,
  p as DrawerHeader,
  l as DrawerOverlay,
  n as DrawerPortal,
  g as DrawerTitle,
  m as DrawerTrigger
};
//# sourceMappingURL=drawer.js.map
